import React from "react";
import PropTypes from "prop-types";
import ThemeContext, { themeNames, initialContextValue } from "./ThemeContext";

const ThemeContextProvider = ({ theme: initialThemeName, children }) => {
  let name = initialThemeName;

  if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
    name = window.GLOBAL_UI_INITIAL_PROPS.theme || name;
  }

  return <ThemeContext.Provider value={name}>{children}</ThemeContext.Provider>;
};

ThemeContextProvider.propTypes = {
  theme: PropTypes.oneOf(themeNames),
  children: PropTypes.element.isRequired,
};

ThemeContextProvider.defaultProps = {
  theme: initialContextValue,
};

export default ThemeContextProvider;
